module.exports = __webpack_public_path__ + "img/send.dccb82cc.png";